import { Ok, Result } from 'ts-res';
import { KameleoonData, PageViewDataType } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class VisitedPages implements ICondition {
  private conditionValue?: number | null;
  private matchType?: MatchType | null;

  constructor({ matchType, pageCount }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = pageCount;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const pageViewsData = targetingData?.[KameleoonData.PageView];

    if (!pageViewsData) {
      return Ok(false);
    }

    let pagesAmount = 0;

    Object.values(pageViewsData).forEach((pageView: PageViewDataType) => {
      pagesAmount += pageView.timestamps.length;
    });

    return Ok(this.checkCondition(pagesAmount));
  }

  private checkCondition(pagesAmount: number): boolean {
    if (!this.matchType || typeof this.conditionValue !== 'number') {
      return false;
    }

    switch (this.matchType) {
      case MatchType.EQUAL:
        return pagesAmount === this.conditionValue;
      case MatchType.GREATER:
        return pagesAmount > this.conditionValue;
      case MatchType.LOWER:
        return pagesAmount < this.conditionValue;
      default:
        KameleoonLogger.error`Unexpected comparing operation for VisitedPages condition: ${this.matchType}`;
        return false;
    }
  }
}
